/* eslint-disable react/prop-types */ // TODO: add props
import ChevronSVG from './ChevronSVG';
import style from './Arrow.scss';

const Arrow = ({ isOpen }) => {
  return (
    <span>
      <ChevronSVG isOpen={isOpen} className={style.chevron} />
    </span>
  );
};

export default Arrow;
